import script from "./UserScreenshotQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./UserScreenshotQuery.vue?vue&type=script&setup=true&lang=js"

import "./UserScreenshotQuery.vue?vue&type=style&index=0&id=1bacb7db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bacb7db"]])

export default __exports__